var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.49 105.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .it-cls-1 {\n        fill: #39fdc1;\n      }\n\n      .it-cls-2, .it-cls-4 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .it-cls-2 {\n        stroke-width: 8px;\n      }\n\n      .it-cls-3 {\n        fill: #fff;\n      }\n\n      .it-cls-4 {\n        stroke-width: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IT"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "it-cls-1",
    cx: 52.74,
    cy: 52.74,
    r: 52.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "it-cls-2",
    x: 29.76,
    y: 29.76,
    width: 45.96,
    height: 45.96,
    rx: 1.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "it-cls-3",
    d: "M446.34,202.74h4.8a0,0,0,0,1,0,0v14.4a0,0,0,0,1,0,0h-4.8a7.2,7.2,0,0,1-7.2-7.2v0A7.2,7.2,0,0,1,446.34,202.74Z",
    transform: "translate(262.68 -424.24) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "it-cls-3",
    d: "M439.14,266.43h4.8a7.2,7.2,0,0,1,7.2,7.2v0a7.2,7.2,0,0,1-7.2,7.2h-4.8a0,0,0,0,1,0,0v-14.4a0,0,0,0,1,0,0Z",
    transform: "translate(326.37 -360.55) rotate(90)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "it-cls-4",
    cx: 52.74,
    cy: 52.74,
    r: 7.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "it-cls-4",
    x1: 52.74,
    y1: 45.36,
    x2: 52.74,
    y2: 29.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "it-cls-2",
    x1: 14.6,
    y1: 45.36,
    x2: 29.76,
    y2: 45.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "it-cls-2",
    x1: 14.6,
    y1: 60.13,
    x2: 29.76,
    y2: 60.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "it-cls-2",
    x1: 75.72,
    y1: 45.36,
    x2: 90.89,
    y2: 45.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "it-cls-2",
    x1: 75.72,
    y1: 60.13,
    x2: 90.89,
    y2: 60.13
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/IT.b55be8254bfae336eceb7b2ea64cef4e.svg";
export { ForwardRef as ReactComponent };